module.exports = __webpack_public_path__ + "img/wheel_back.3328b1a1.png";